var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline-block"},[(_vm.value)?_c('ZTickSvg'):_c('ZTickEmptySvg')],1)}
var staticRenderFns = []

export { render, staticRenderFns }